import styled from "styled-components";
import { colors } from "../../../../assets";

export const NewCampaignContainer = styled.div`
  .col-1 {width: 8.33% !important;}
  .col-2 {width: 16.66%; !important}
  .col-3 {width: 25%;}
  .col-4 {width: 33.33%;}
  .col-5 {width: 41.66%;}
  .col-6 {width: 50%;}
  .col-7 {width: 58.33%;}
  .col-8 {width: 66.66%;}
  .col-9 {width: 75%;}
  .col-10 {width: 83.33%;}
  .col-11 {width: 91.66%;}
  .col-12 {width: 100%;}

  .leftMargin30 {
    margin-left: 30px;
  }
  
  .col-25 {
    width: 25%;
  }

  .col-33 {
    width: 33%;
  }

  .col-50 {
    width: 50%;
  }

  .col-75 {
    width: 75%;
  }

  .col-100 {
    width: 100%;
  }


  .campaings-title {
    width: max-content;
  }

  .main-title-container-complex {
    margin-bottom: 38px;
    color: #004F8B;
    width: auto;
    display: flex;
  }

  .main-title-container-complex-item {  
      margin-right: 58%;    
  }

  .campaign-data-row {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
  }

  .campaign-data-item {
    margin-right: 40px;

    &:last-child {
      margin-right: 0;
    }
  }

  .campaign-data-product{
    columns: 2 auto;

    .campaign-data-item {
      margin-right: 10px;
    }
  }

  .inputBox.dicotomic {
    padding-top: 0;
  }

  .product-filter-container .tabs-container {
    position: relative;
    width: fit-content;
    margin-bottom: 35px;

    &__tabs {
      display: flex;
      border-bottom: 0.5px solid #B5BCC6;
      padding: 0 15px 0px;
      div {
        cursor: pointer;
        font-size: 16px;
        line-height: 17px;
        text-transform: uppercase;
        color: #B5BCC6;
        transition: color .2s ease-in-out;
        margin-right: 28px;
        min-width: 65px;
        text-align: center;

        &:last-child {
          margin-right: 0px;
        }
      }
      .selected {
        color: #004F8B;
        border-bottom: 4px solid #004F8B;
        padding-bottom: 10px;
        transition: right .2s ease-in-out;
      }
    }

    .selected-right {
      left: 0;
    }
  }

  .campaign-products h5 {
    margin: 10px 0 5px;
  } 

  .product-filter-container {
    width: 100%;
    margin-bottom: 15px;
    background-color: #fbfbfb;
    padding: 20px;

    .keep-calm {
      padding: 1px 3px;
      background: ${colors["AL-001-20"]};
      font-size: 15px;
      margin-bottom: 30px;
  
      p {
        color: ${colors["SC-004-100"]};
        padding-right: 0;
      }
    }
  }
`;
